import React from 'react';
import { Suspense, useEffect, useRef, useState } from 'react';
import { MapBox, AppProps } from 'eyeon-threejs-map';
import 'eyeon-threejs-map/index.css'

function App() {
  const appRef = useRef<HTMLDivElement>(null)
  const [args, setArgs] = useState<AppProps | null>(null);

  const configRef = useRef<AppProps>({
    config: {
      ROLE: "WP_SITE",
      CENTER_ID: 8,
      SELECTED_RETAILER_ID: 6388,
    },
    webApiURI: 'https://web-backend-prod.eyeonportal.com/'
  });

  useEffect(() => {
    if (appRef.current) {
      const parent = appRef.current.parentElement as HTMLDivElement;
      if (parent) {
        const props = parent.dataset.props;
        if (props) {
          const decoded = JSON.parse(props);
          if (decoded) {
            const newArgs = { ...configRef.current, ...decoded }
            setArgs({ ...newArgs })
          }
        }
      }
    }
  }, [])

  return (
    <div className="App" ref={appRef}>
      <Suspense>
        {args === null ? <div>Loading config</div> : args && <MapBox {...args} />}
      </Suspense>
    </div>
  );
}

export default App;

